import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { FirewallSecurityGroupMetadataBase } from '../../@types/firewall-security-group';
import { Endpoints } from '../../apis';
import { getErrorMessage } from '@xver/utils/error';

export function useCreateSecurityGroupMutate() {
    const { t } = useTranslation('notifications');
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (body: FirewallSecurityGroupMetadataBase) =>
            Endpoints.v1.Firewalls.SecurityGroups.createSecurityGroup(body),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['api.v1.firewalls.security-groups.infinite'],
            });
            notifications.show({
                title: t('securityGroup.createdTitle'),
                message: t('securityGroup.createdMessage'),
                icon: <IconCheck size={32} color={'#00ff00'} />,
            });
        },
        onError: (error: any) => {
            notifications.show({
                title: t('securityGroup.createFailedTitle'),
                message: getErrorMessage(error),
                icon: <IconExclamationCircle size={32} color={'#eb5757'} />,
            });
        },
    });
}
